import { render, staticRenderFns } from "./ConversationForm.vue?vue&type=template&id=d376305a&scoped=true&"
import script from "./ConversationForm.vue?vue&type=script&lang=js&"
export * from "./ConversationForm.vue?vue&type=script&lang=js&"
import style0 from "./ConversationForm.vue?vue&type=style&index=0&id=d376305a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d376305a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d376305a')) {
      api.createRecord('d376305a', component.options)
    } else {
      api.reload('d376305a', component.options)
    }
    module.hot.accept("./ConversationForm.vue?vue&type=template&id=d376305a&scoped=true&", function () {
      api.rerender('d376305a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/contact/ConversationForm.vue"
export default component.exports